import React, { Dispatch, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Home from "../screens/Home";
import Privacy from "../screens/Privacy";
import Terms from "../screens/Terms";
import Refund from "../screens/Refund";

const AppRouter: React.FC = () => {
    const NotFound: React.FC = () => (
        <div>
            <h2>404 - Not Found</h2>
            {/* You can add more content or a link to the home page */}
        </div>
    );

    return (
        <Routes>
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/:link?" element={<Home />} />
        </Routes>
    );
};

export default AppRouter;
